import PlusIcon from "components/Icons/PlusIcon"
import {
  FoodBottomInfo,
  FoodBrand,
  FoodImageBox,
  FoodInfoBox,
  FoodLeft,
  FoodName,
  FoodNameBox,
  FoodNutrient,
  StyledFoodListItem,
  AddFoodButton,
} from "./styled"
import Highlighter from "react-highlight-words"
import { getDisplayCalories, getDisplayPortion } from "utils"
import { useState } from "react"
import SmallFoodImage from "components/foodDetails/share/SmallFoodImage"
import MyFoodIcon from "components/Icons/MyFood"
import { useFoodBrandMaxWidth } from "utils/hooks"
import { formatUnit } from "utils/formater"
import {
  isEdamaFood,
  isMyFood,
} from "model/food/utils/typeGuards/foodTypeGuards"
import ArrowRightIcon from "../share/ArrowRightIcon"
import FoodAddedButton from "../share/AddFoodButton"
import {
  IEdamaFoodSearchResult,
  IEdamaIngredientOption,
} from "model/food/types/edama.types"

interface Iprops<T extends IEdamaFoodSearchResult | IEdamaIngredientOption> {
  food: T
  keyword?: string
  onSelect?: (food: T) => void
  onAdd?: (food: T) => void
  hideAddBtn?: boolean
  style?: React.CSSProperties
  hasArrow?: boolean
}

const EdamaIngredientItem = <
  T extends IEdamaFoodSearchResult | IEdamaIngredientOption,
>(
  props: Iprops<T>,
) => {
  const {
    food,
    keyword,
    onSelect,
    onAdd,
    hideAddBtn,
    style = {},
    hasArrow,
  } = props
  const { name, imageUrl, calorie, unit, portion } = food
  const [showAddedIcon, setShowAddedIcon] = useState(false)

  const handleAddFood = () => {
    setShowAddedIcon(true)

    onAdd?.(food)

    setTimeout(() => {
      setShowAddedIcon(false)
    }, 1000)
  }

  const { brandMaxWidth, foodNutritionRef } = useFoodBrandMaxWidth({
    brand: food.brand ?? "",
  })

  const isEdama = isEdamaFood(food)
  const hasMyFoodIcon = isMyFood(food)

  return (
    <StyledFoodListItem style={style}>
      <FoodLeft onClick={() => onSelect?.(food)} $hideAddBtn={hideAddBtn}>
        <FoodImageBox>
          <SmallFoodImage src={imageUrl} />
        </FoodImageBox>
        <FoodInfoBox>
          <FoodNameBox>
            <FoodName>
              {" "}
              {keyword ? (
                <Highlighter
                  highlightClassName="high-light-text"
                  searchWords={keyword.split(" ")}
                  autoEscape={true}
                  textToHighlight={name}
                />
              ) : (
                name
              )}
            </FoodName>
            {hasMyFoodIcon && <MyFoodIcon />}
          </FoodNameBox>

          <FoodBottomInfo>
            <FoodNutrient ref={foodNutritionRef}>
              {getDisplayCalories(calorie)} cal, {getDisplayPortion(portion)}{" "}
              {formatUnit(unit, isEdama)}{" "}
            </FoodNutrient>

            {isEdama && food.brand && (
              <FoodBrand style={{ maxWidth: brandMaxWidth }}>
                <p>{food.brand}</p>
              </FoodBrand>
            )}
          </FoodBottomInfo>
        </FoodInfoBox>
      </FoodLeft>

      {hasArrow && <ArrowRightIcon />}

      {!hideAddBtn &&
        (showAddedIcon ? (
          <FoodAddedButton />
        ) : (
          <AddFoodButton onClick={() => handleAddFood()}>
            <PlusIcon />
          </AddFoodButton>
        ))}
    </StyledFoodListItem>
  )
}

export default EdamaIngredientItem
